import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
let CustomFieldDefinitionModel = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = belongsTo('organization_custom_field', {
  inverse: 'custom_field_definitions',
  async: false
}), _dec4 = attr('boolean', {
  defaultValue: false
}), _class = class CustomFieldDefinitionModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "rank", _descriptor2, this);
    _initializerDefineProperty(this, "organization_custom_field", _descriptor3, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor4, this);
  }
  get label() {
    return this.name || '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "organization_custom_field", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { CustomFieldDefinitionModel as default };
//# sourceMappingURL=custom-field-definition.js.map
